import { gravity as viemGravity } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const gravity = {
  displayName: 'Gravity Alpha',
  runtime: 'evm',
  viemChain: viemGravity,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'gravity-alpha' },
    qnStreams: {
      networkKey: 'gravity-alpham',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
